export function orderDateFilters({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onApply,
  onReset,
}) {
  return (
    <div className="order-filters">
      <div className="order-date-field">
        <label htmlFor="orderStartDate">Start date</label>
        <input
          id="orderStartDate"
          className="order-date-input"
          type="date"
          value={startDate}
          max={endDate || undefined}
          onChange={(e) => onStartDateChange(e.target.value)}
        />
      </div>

      <div className="order-date-field">
        <label htmlFor="orderEndDate">End date</label>
        <input
          id="orderEndDate"
          className="order-date-input"
          type="date"
          value={endDate}
          min={startDate || undefined}
          onChange={(e) => onEndDateChange(e.target.value)}
        />
      </div>

      <div className="order-date-actions">
        <button type="button" className="order-filter-btn" onClick={onApply}>
          Apply filters
        </button>

        <button type="button" className="order-reset-btn" onClick={onReset}>
          Reset
        </button>
      </div>
    </div>
  );
}
